import { PageItemWithCountries } from './page-item';
import { PartialProgram } from './program';
import { UploadedFileViewModel } from '../file-upload/components/file-upload.view-model';
import { TrayWithLocalizedTitle, TrayWithScheduling, TrayWithLayoutObject, TrayWithLocalizedDescription } from './tray-common';

export enum SinglePhotoSeasonTrayContentSort {
  Ascending = 'Ascending',
  Descending = 'Descending',
}

export interface SinglePhotoSeasonTray
  extends TrayWithLocalizedTitle,
    TrayWithLocalizedDescription,
    PageItemWithCountries,
    TrayWithScheduling,
    TrayWithLayoutObject {
  type: 'SinglePhotoSeasonTray';
  sort: SinglePhotoSeasonTrayContentSort;
  program?: PartialProgram;
  displayServiceTypeIcon: boolean;
  image: UploadedFileViewModel;
}
